import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "p-mt-3" }, [
  /*#__PURE__*/_createTextVNode(" If you want to specify a single facet.query parameter just define in this way "),
  /*#__PURE__*/_createVNode("pre", null, "price:[500 TO *]"),
  /*#__PURE__*/_createTextVNode(" If you want to specify multiple facet.query parameters you need to add also the prefix facet.query= and separate the values with &. You should also use same encoding like you are writing an URL. For example "),
  /*#__PURE__*/_createVNode("pre", null, "facet.query=price:[*+TO+500]&facet.query=price:[500+TO+*]")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$t('managers.datasetManagement.helpTitle'),
    style: _ctx.detailDescriptor.style.infoDialog,
    visible: _ctx.visible,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["header", "style", "visible"]))
}